import styled, { keyframes } from "styled-components";
import { fadeIn } from "../../../utils/styleEffects";
import Login from "../../../images/fondos/login.svg";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-image: url(${Login});
  background-size: contain;
  animation: 0.9s ${fadeIn} forwards;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const LateralMenuContainer = styled.div`
  display: flex;
  width: 10%;
  height: 100%;
  overflow: hidden;
`;
